// extracted by mini-css-extract-plugin
export default {"defaultPadding":"DefaultModalBody_defaultPadding__a1De7","fullWidth":"DefaultModalBody_fullWidth__0U6IZ"};